





































import { Component, Vue, Prop } from "vue-property-decorator";
import { urlCheck, mailCheck } from "@/services/utils";

export default {
    name: "SocialContacts",
    props: ["error", "value"],
    methods: {
        urlCheck,
        mailCheck
    }
};
